import * as z from 'zod'
import { ZodError } from 'zod'
import chalk from 'chalk'
import { NotificacionAumentadaZod, type NotificacionAumentada } from './tipos/notificaciones'

const version =
  (typeof process !== 'undefined' && process?.env?.npm_package_version)
  || (typeof process !== 'undefined' && process?.env?.VITE_APP_VERSION)
  || (typeof process !== 'undefined' && process?.env?.NUXT_PUBLIC_APP_VERSION)
  || 'dev'

 
export const OpcionesErrorAumentadoZod = z.object({
  error: z.any().optional(),
  datos: z.any().optional(),

  origen: z.string().optional(),
  alertar: z.boolean().optional(),

  respuesta: z
    .object({
      code: z.number().optional(),
      codigo: z.string(),
      desconectar: z.literal(true).optional(),
      rotarLlavero: z.literal(true).optional(),
      rotarRegistro: z.literal(true).optional(),
      datos: z.any().optional(),
      notificacion: NotificacionAumentadaZod.optional(),
      notificaciones: z.array(NotificacionAumentadaZod).optional()
    })
    .optional()
})
export type OpcionesErrorAumentado = z.infer<typeof OpcionesErrorAumentadoZod>
export class ErrorAumentado extends Error {
  version: string
  trazado: string[] = []

  alertar = true

  override cause?: Error
  origen?: string

  datos?: unknown

  respuesta?: {
    code?: number
    codigo: string
    datos?: unknown,
    desconectar?: true
    rotarLlavero?: true
    rotarRegistro?: true
    notificacion?: NotificacionAumentada
    notificaciones?: NotificacionAumentada[]
  }

  constructor(message: string, opciones?: OpcionesErrorAumentado) {
    super(message)
    this.version = version
    this.name = 'ErrorAumentado'
    this.alertar = ((): boolean => {
      if (opciones) {
        if (typeof opciones.alertar !== 'undefined')
          return opciones.alertar
        if (!opciones.respuesta)
          return true
        return false
      }
      else { return true }
    })()

    if (message === 'usuarioEliminado') {
      this.respuesta = {
        code: 409,
        codigo: 'cuentaEliminada',
        desconectar: true
      }
    }

    if (opciones) {
      if (opciones.origen) {
        this.origen = opciones.origen
        this.trazado.push(opciones.origen)
      }
      this.cause = opciones.error

      if (opciones.error instanceof ZodError && this.alertar) {
        console.error('\n', chalk.bgRed.bold(' Error de parseo '))
        // mostrar stack

        console.error('\nStack: ', this.stack)

        // console.error('issues \n', inspect(opciones.error.issues))
        const issues = opciones.error.issues
        for (const [issueID, issue] of Object.entries(issues)) {
          const {
            path,
            code,
            message,
            expected,
            received
          } = Object.assign({
            expected: '',
            received: ''
          }, issue)
          console.error(`Issue ${issueID} @ ${path.join(' . ')}\n`, `expected: ${expected}; received: ${received}\n`, `code: ${code}; message: ${message}`)
        }
        if (opciones.datos)
          console.error('datos: ', opciones.datos)
      }

      if (opciones.error) {
        const { name, message } = opciones.error
        console.log({ name, message })
        if (name === 'SequelizeConnectionRefusedError') {
          this.message = 'conexionFallidaSDB'
          //
          opciones.respuesta = {
            code: 500,
            codigo: 'conexionFallidaSDB'
          }
          opciones.alertar = true
        }
        if (name === 'MongoNetworkError') {
          this.message = 'conexionFallidaDB'
          //
          opciones.respuesta = {
            code: 500,
            codigo: 'conexionFallidaDB'
          }
          opciones.alertar = true
        }
      }

      if (opciones.datos)
        this.datos = opciones.datos

      if (opciones.respuesta)
        this.respuesta = opciones.respuesta
      else if (!opciones.respuesta && this.alertar)
        console.error(chalk.red('ErrorAumentado: '), chalk.yellow(message))
    }
  }

  retornarAlCliente({
    solicitudIDColor,
    solicitudID,
    responder
  }: {
    solicitudIDColor: string
    solicitudID: string
    responder: ({ code, cuerpoRespuesta }: { code: number, cuerpoRespuesta: unknown }) => void
  }) {
    if (this.alertar) {
      this.alertarlo()
    }

    if (this.respuesta) {
      const respuesta = this.respuesta
      const cuerpoRespuesta = {
        ok: false,
        error: respuesta.codigo,
        datos: respuesta.datos,
        desconectar: respuesta.desconectar,
        rotarLlavero: respuesta.rotarLlavero,
        rotarRegistro: respuesta.rotarRegistro,
        notificacion: respuesta.notificacion,
        notificaciones: respuesta.notificaciones
      }
      if (this.alertar !== false) {
        console.warn(solicitudIDColor ?? solicitudID, 'Respondiendo con: ', respuesta.code ?? 200, cuerpoRespuesta)
      }

      return responder({
        code: respuesta.code ?? 200,
        cuerpoRespuesta
      })
    }
    if (this.alertar !== false) {
      console.error('Respondiendo con 500: ErrorInesperado')
    }
    return responder({
      code: 500,
      cuerpoRespuesta: { ok: false, error: 'ErrorInesperado' }
    })
  }

  trazar(fx: string) {
    this.trazado.push(fx)
    if (!this.alertar)
      return this
    console.log('  Agregado al trazado: ', fx)
    return this
  }

  alertarlo() {
    const esDeZod = this.cause instanceof ZodError
    esDeZod ? console.error('---------ZodError----------') : console.error('-------------------')

    console.error(
      chalk.red('\n ALERTA '),
      chalk.yellow('ALERTA'),
      chalk.red(' ALERTA '),
      chalk.yellow('ALERTA')
    )
    const { trazado, datos, respuesta, message } = this
    console.error('message:', message)
    console.error('trazado:', trazado)
    console.error('datos', datos)
    console.error('respuesta:', respuesta)
    console.error(
      chalk.red(' ALERTA '),
      chalk.yellow('ALERTA'),
      chalk.red(' ALERTA '),
      chalk.yellow('ALERTA')
    )
    esDeZod ? console.error('---------ZodError----------') : console.error('-------------------')
    // console.error('-------------------')
  }

  // trazar(fx: string) {
  //   console.log('  Agregado al trazado: ', fx)
  //   this.trazado.push(fx)
  //   return this
  // }
}
